import lottie from "lottie-web";
import animationData from "../../../lottie/flavourchart.json";

function easeOut(t) {
  return 1 - (1 - t) ** 2;
}
function playWithEasing(animation, to) {
  if (!animation) {
    return;
  }
  let startTime = 0;
  const duration = Math.max(300, to * 10);
  const run = (timestamp) => {
    if (!startTime) {
      startTime = timestamp;
    }
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const animationValue = easeOut(progress) * to;
    animation.goToAndStop(animationValue, true);

    if (animationValue < to) {
      requestAnimationFrame(run);
    }
  };

  requestAnimationFrame(run);
}

// eslint-disable-next-line import/prefer-default-export
export const animateFlavors = () => {
  const flavorContainers = document.querySelectorAll("[data-flavor-container]");

  flavorContainers.forEach((container) => {
    const flavorAnimations = container.querySelectorAll("[data-flavor-value]");
    const flavorCharts = [];

    flavorAnimations.forEach((animation, index) => {
      if (animation.childNodes.length) {
        return;
      }
      const flavorValue = animation.getAttribute("data-flavor-value");

      flavorCharts.push(
        lottie.loadAnimation({
          container: animation,
          renderer: "svg",
          loop: false,
          autoplay: false,
          animationData,
          name: flavorValue + index,
        })
      );
    });

    const runAnimation = () => {
      flavorAnimations.forEach((animation, index) => {
        const flavorValue = animation.getAttribute("data-flavor-value");
        const animationObject = flavorCharts.find(
          (object) => object.name === flavorValue + index
        );

        playWithEasing(animationObject, Math.min(flavorValue, 97));
      });
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          runAnimation();
          // eslint-disable-next-line no-use-before-define
          observer.unobserve(container);
        }
      });
    };

    const observerOptions = {
      root: null,
      threshold: 1,
    };

    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions
    );

    observer.observe(container);
  });
};

document.addEventListener("DOMContentLoaded", animateFlavors);
